import ApiService from "../api/ApiService";

class PackageService {
    getPackageDetails() {
        return ApiService.get("/Apipackagedetails");
    }

    getRateUs() {
        return ApiService.get("/rateUs");
    }

    getShareUs() {
        return ApiService.get("/shareus");
    }
}

export default new PackageService();